{
  "common": {
    "total": "Jami: {{count}} ta",
    "index": "T.r.",
    "actions": "Harakat",
    "actionsLabel": "Amallar",
    "createdAt": "Yaratilgan vaqti",
    "createdBy": "Qo'shgan xodim",
    "edit": "Tahrirlash",
    "delete": "O'chirish",
    "details": "Batafsil",
    "back": "Ortga qaytish",
    "cancel": "Bekor qilish",
    "save": "Saqlash",
    "close": "Yopish",
    "saved": "Saqlandi",
    "deleted": "O'chirildi",
    "error": "Xatolik yuz berdi",
    "loadError": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "notFound": "Hech narsa topilmadi",
    "notFoundHint": "Qidiruv so'zini o'zgartirib ko'ring.",
    "clear": "Tozalash",
    "required": "Bo'sh maydonni to'ldiring",
    "nameTaken": "Bu nom allaqachon mavjud",
    "codeTaken": "Bu kod allaqachon mavjud",
    "system": "Tizim",
    "none": "Tanlanmagan",
    "select": "Tanlang",
    "unsavedTitle": "O'zgarishlar saqlanmagan",
    "unsavedText": "Kiritilgan ma'lumotlar yo'qoladi.",
    "stay": "Qolish",
    "leave": "Chiqish",
    "noRight": "Bu amal uchun huquqingiz yo'q",
    "loading": "Yuklanmoqda..."
  },
  "module": {
    "tabsLabel": "Qurilma boshqaruvi bo'limlari",
    "categories": "Qurilma turkumi",
    "locations": "Qurilma joylashgan o'rni",
    "info": "Qurilma haqida ma'lumot",
    "calibration": "Qurilma kolibrovkalash",
    "config": "Qurilma konfiguratsiya"
  },
  "categories": {
    "title": "Qurilma turkumi",
    "create": "Qurilma turkumini yaratish",
    "editTitle": "Qurilma turkumini tahrirlash",
    "search": "Turkum nomi bo'yicha izlash",
    "column": "Qurilma turkumi",
    "field": "Qurilma turkumi nomi",
    "placeholder": "Turkum nomini kiriting",
    "empty": "Turkumlar mavjud emas",
    "emptyHint": "Hali birorta qurilma turkumi qo'shilmagan.",
    "deleteTitle": "Turkumni o'chirasizmi?",
    "deleteText": "«{{name}}» turkumi o'chiriladi.",
    "inUseTitle": "Turkumni o'chirib bo'lmaydi",
    "inUseText": "Bu turkumga {{count}} ta qurilma biriktirilgan.",
    "icon": "Belgisi",
    "color": "Rangi"
  },
  "locations": {
    "title": "Qurilma joylashgan o'rni",
    "create": "Joylashuv o'rnini yaratish",
    "editTitle": "Joylashuv o'rnini tahrirlash",
    "search": "Joylashuv nomi bo'yicha izlash",
    "column": "Qurilma joylashgan o'rni",
    "field": "Joylashgan o'rni nomi",
    "placeholder": "Joylashuv nomini kiriting",
    "empty": "Joylashuv o'rinlari mavjud emas",
    "emptyHint": "Hali birorta joylashuv o'rni qo'shilmagan.",
    "deleteTitle": "Joylashuv o'rnini o'chirasizmi?",
    "deleteText": "«{{name}}» o'chiriladi.",
    "deleteInUse": "«{{name}}» o'chiriladi. {{count}} ta qurilmaning joylashuvi bo'shatiladi."
  },
  "info": {
    "title": "Qurilma haqida ma'lumot",
    "create": "Qurilma ma'lumotini yaratish",
    "editTitle": "Qurilma ma'lumotini tahrirlash",
    "search": "Qurilma nomi bo'yicha izlash",
    "category": "Qurilma turkumi",
    "location": "Joylashgan o'rni",
    "name": "Qurilma nomlanishi",
    "serial": "Seriya raqami",
    "passport": "Pasport",
    "passportLong": "Kolibrovka pasporti",
    "passportBadge": "Pasport.{{ext}}",
    "empty": "Qurilmalar mavjud emas",
    "emptyHint": "Qurilma ma'lumotini yaratish tugmasini bosib birinchi qurilmani qo'shing.",
    "nameLabel": "Qurilma nomlanishini tanlang",
    "namePlaceholder": "Qurilma nomini kiriting",
    "discovered": "Manbadan aniqlangan qurilmalar",
    "codeLabel": "Qurilma kodi",
    "codePlaceholder": "Avtomatik",
    "categoryLabel": "Qurilma turkumini tanlang",
    "locationLabel": "Qurilma joylashgan o'rnini tanlang",
    "serialLabel": "Qurilma seriya raqami",
    "serialPlaceholder": "Seriya raqamini kiriting",
    "modelLabel": "Qurilma modeli",
    "modelPlaceholder": "Modelni kiriting",
    "statusLabel": "Holati",
    "passportLabel": "Kolibrovka pasporti",
    "upload": "Fayl yuklash",
    "uploading": "Yuklanmoqda...",
    "replaceFile": "Faylni almashtirish",
    "removeFile": "Faylni olib tashlash",
    "passportHint": "PDF yoki rasm (PNG, JPG), 100 MB gacha",
    "fileType": "Faqat PDF, PNG yoki JPG fayl yuklash mumkin",
    "fileSize": "Fayl hajmi 100 MB dan oshmasin",
    "created": "Qurilma qo'shildi",
    "deleteTitle": "Qurilmani o'chirasizmi?",
    "deleteText": "«{{name}}» va uning ko'rsatkichlari o'chiriladi. O'lchovlar tarixi saqlanadi.",
    "viewPassport": "Pasportni ko'rish"
  },
  "statuses": {
    "active": "Faol",
    "inactive": "Faol emas",
    "maintenance": "Ta'mirda"
  },
  "indicators": {
    "title": "Ko'rsatkichlar",
    "add": "Ko'rsatkich qo'shish",
    "empty": "Ko'rsatkichlar mavjud emas",
    "saveFirst": "Ko'rsatkich qo'shish uchun avval qurilmani saqlang.",
    "createTitle": "Ko'rsatkich qo'shish",
    "editTitle": "Ko'rsatkichni tahrirlash",
    "name": "Ko'rsatkich nomi",
    "namePlaceholder": "Masalan: Suv sathi",
    "code": "Kodi",
    "kind": "Turi",
    "physical": "Fizik",
    "virtual": "Virtual",
    "unit": "O'lchov birligi",
    "unitPlaceholder": "Masalan: m",
    "precision": "Kasr xonalari",
    "thresholds": "Chegaralar (mezon)",
    "warningLow": "M-1 quyi",
    "warningHigh": "M-1 yuqori",
    "alarmLow": "M-2 quyi",
    "alarmHigh": "M-2 yuqori",
    "alarm": "Mezon nazorati",
    "alarmHint": "Chegaradan chiqilganda ogohlantirish beriladi",
    "alarmNoRight": "Mezonni yoqish uchun «Qurilmalar» bo'limini tahrirlash huquqi kerak",
    "color": "Rangi",
    "chartType": "Diagramma turi",
    "channel": "Yagona server kanali",
    "channelPlaceholder": "Masalan: hydro:LEVEL",
    "channelCustom": "Boshqa kanal",
    "source": "Manba ko'rsatkich (x)",
    "formula": "Formula",
    "deleteTitle": "Ko'rsatkichni o'chirasizmi?",
    "deleteText": "«{{name}}» o'chiriladi.",
    "invalidNumber": "Son kiriting",
    "m2High": "M-2 yuqori chegarasi M-1 dan kichik bo'lmasin",
    "m2Low": "M-2 quyi chegarasi M-1 dan katta bo'lmasin",
    "lowHigh": "Quyi chegara yuqori chegaradan kichik bo'lishi kerak",
    "physicalCount": "{{count}} ta fizik",
    "virtualCount": "{{count}} ta virtual"
  },
  "chartTypes": {
    "auto": "Random",
    "line": "Chiziqli",
    "bar": "Ustunli",
    "area": "Maydonli",
    "scatter": "Nuqtali",
    "step": "Pog'onali"
  },
  "colors": {
    "auto": "Random",
    "custom": "Maxsus",
    "blue": "Ko'k",
    "green": "Yashil",
    "darkGreen": "To'q yashil",
    "yellow": "Sariq",
    "orange": "To'q sariq",
    "red": "Qizil",
    "pink": "Pushti",
    "purple": "Binafsha"
  },
  "detail": {
    "title": "Batafsil ma'lumot",
    "category": "Qurilma turkumi",
    "location": "Qurilma joylashgan o'rni",
    "serial": "Qurilma seriya raqami",
    "createdAt": "Yaratilgan vaqti",
    "createdBy": "Kim tomonidan yaratilgan",
    "code": "Qurilma kodi",
    "model": "Qurilma modeli",
    "status": "Holati",
    "indicators": "Ko'rsatkichlar"
  },
  "passport": {
    "title": "Kolibrovka pasporti ko'rish",
    "download": "Yuklab olish",
    "missing": "Pasport yuklanmagan",
    "missingHint": "Qurilma ma'lumotini tahrirlab kolibrovka pasportini yuklang.",
    "frameTitle": "Kolibrovka pasporti",
    "fullscreen": "To'liq ekran"
  },
  "calibration": {
    "title": "Qurilma kolibrovkalash",
    "sourceLabel": "Qurilma ko'rsatkichini tanlang",
    "sourcePlaceholder": "Ko'rsatkichni tanlang",
    "deviceInfo": "Qurilma haqida ma'lumot",
    "readingsTitle": "Qurilmaga kelgan ko'rsatkichlar (CSV fayl asosida)",
    "date": "Sana",
    "value": "Ko'rsatkich",
    "noReadings": "O'lchovlar hali kelmagan",
    "formulaTitle": "Formula yaratish",
    "formulaLabel": "Formulani kiriting",
    "formulaPlaceholder": "Masalan: 0,0001 * x³ + 0,12 * x + 1",
    "formulaError": "Formula xato: {{message}}",
    "formulaHint": "x — tanlangan ko'rsatkichning qiymati",
    "nameLabel": "Ko'rsatkich nomini yozing",
    "namePlaceholder": "Masalan: Blok P - 1 bosimi",
    "unitLabel": "O'lchov birligini tanlang",
    "chartLabel": "Diagramma turi",
    "colorLabel": "Rangi",
    "newFormula": "Yangi formula",
    "addFormula": "Yangi formula qo'shish",
    "deleteFormula": "Formulani o'chirish",
    "deleteTitle": "Formulani o'chirasizmi?",
    "deleteText": "«{{name}}» virtual ko'rsatkichi o'chiriladi.",
    "empty": "Fizik ko'rsatkichlar mavjud emas",
    "emptyHint": "Kolibrovka uchun avval qurilma va uning fizik ko'rsatkichini qo'shing.",
    "pickSource": "Kolibrovka uchun fizik ko'rsatkichni tanlang",
    "readOnly": "Formulalarni o'zgartirish uchun huquqingiz yo'q",
    "virtualCount": "Virtual ko'rsatkichlar"
  },
  "config": {
    "title": "Qurilma konfiguratsiya",
    "search": "Qurilma nomi bo'yicha izlash",
    "create": "Qurilma qo'shish",
    "code": "Qurilma kodi",
    "name": "Qurilma nomi",
    "category": "Turkum",
    "location": "Joylashuv",
    "source": "Manba",
    "lastReading": "Oxirgi qiymat vaqti",
    "status": "Holat",
    "indicators": "Ko'rsatkichlar",
    "allCategories": "Barcha turkumlar",
    "allLocations": "Barcha joylashuvlar",
    "allStatuses": "Barcha holatlar",
    "allSources": "Barcha manbalar",
    "empty": "Qurilmalar mavjud emas",
    "categoryFilter": "Turkum bo'yicha filtr",
    "locationFilter": "Joylashuv bo'yicha filtr",
    "statusFilter": "Holat bo'yicha filtr",
    "sourceFilter": "Manba bo'yicha filtr"
  },
  "sources": {
    "manual": "Qo'lda",
    "unified": "Yagona server",
    "csv": "CSV fayl"
  },
  "monitoring": {
    "tabsLabel": "Ma'lumot monitoringi bo'limlari",
    "devicesTab": "Qurilma ma'lumoti",
    "physicalTab": "Fizik ko'rsatkichlar monitoringi",
    "virtualTab": "Virtual ko'rsatkichlar monitoringi",
    "devicesTitle": "Qurilma ma'lumoti",
    "physicalTitle": "Fizik ko'rsatkichlar",
    "virtualTitle": "Virtual ko'rsatkichlar",
    "search": "Qurilma nomi bo'yicha izlash",
    "filter": "Filtrlash",
    "category": "Qurilma turkumi",
    "location": "Joylashgan o'rni",
    "name": "Qurilma nomlanishi",
    "serial": "Seriya raqami",
    "passport": "Kolibrovka pasporti",
    "formula": "Formula",
    "formulaYes": "Mavjud",
    "formulaNo": "Mavjud emas",
    "deviceName": "Qurilma nomi",
    "device": "Qurilma",
    "time": "O'lchov vaqti",
    "value": "Qiymati",
    "sourceFile": "Source fayl nomi",
    "unit": "O'lchov birligi",
    "status": "Holat",
    "liveStatus": "Jonli holat: {{status}}",
    "history": "O'lchovlar tarixi",
    "emptyDevices": "Qurilmalar mavjud emas",
    "emptyPhysical": "Fizik ko'rsatkichlar mavjud emas",
    "emptyVirtual": "Virtual ko'rsatkichlar mavjud emas",
    "emptyVirtualHint": "Virtual ko'rsatkichlar «Qurilma kolibrovkalash» bo'limida formula orqali yaratiladi.",
    "filterTitle": "Filtrlash",
    "anyCategory": "Barcha turkumlar",
    "anyLocation": "Barcha joylashuvlar",
    "anyStatus": "Barcha holatlar",
    "reset": "Tozalash",
    "openCalibration": "Kolibrovkaga o'tish"
  },
  "history": {
    "title": "O'lchovlar tarixi",
    "range1d": "1 kun",
    "range7d": "7 kun",
    "range30d": "30 kun",
    "rangeAll": "Barchasi",
    "rangeLabel": "Davr",
    "min": "Min",
    "max": "Max",
    "avg": "O'rtacha",
    "last": "Oxirgi qiymat",
    "count": "{{count}} ta o'lchov",
    "empty": "Bu davrda o'lchovlar yo'q",
    "noRight": "Tarixni ko'rish uchun huquqingiz yo'q",
    "lastUpdate": "Oxirgi yangilanish: {{time}}"
  }
}
